
'use strict';

  (function init() {
    const $links = $('a');
    // console.log($links);

    $links.each(function(index, link) {
      const $link = $(link);
      const href = $link.attr('href');
      // console.log(href);

      if (href.includes('/collections/')) {
        if (!href.includes('/products/')) {
          const hrefUpdated = addDefaultFilter(href);
          $link.attr('href', hrefUpdated);
          //console.log(hrefUpdated);
        }
      }
    });
  })();


  function addDefaultFilter(href) {
    // Create a temporary URL object to manipulate the href
    // If url is an absolute URL, a given base will not be used to create the resulting URL.
    var url = new URL(href, window.location.origin);

    // Get the search parameters from the URL
    var params = new URLSearchParams(url.search);

    // Update the quantity parameter value
    if (!params.get('filter.v.availability')) {
      params.set('filter.v.availability', '1');
    }

    // Update the URL with the modified search parameters
    url.search = params.toString();

    // Return the updated href
    return url.toString();
  }

$(document).ready(function() {
    // Find the "På lager" input element
    const $inputs = $('[name="filter.v.availability"]');

    if (!$inputs.length) {
      return;
    }

    let $found;
    $inputs.each(function(index, input) {
      const $input = $(input);
      $input.siblings().each(function(index, sibling) {
        const $sibling = $(sibling);
        console.log($sibling.text());
        if ($sibling.text().trim() === 'På lager') {
          console.log('Found', $input);
          if ($input.prop('checked') === false) {
            $input.trigger('click');
          }
        }
      });
    });

  });

